import {Card} from 'antd';
import cn from 'classnames';
import React from 'react';

import {TJSXContent} from 'shared/types';

import './directories-company-form-card.less';

interface IDirectoriesCompanyFormCardProps {
    className?: cn.Argument;
    title: string;
    children: TJSXContent;
}

export const DirectoriesCompanyFormCard = ({className, title, children}: IDirectoriesCompanyFormCardProps) => (
    <Card
        className={cn('directories-company-form-card', className)}
        title={title}
    >
        {children}
    </Card>
);
